import {css} from 'lit';

export const checkboxOnDarkStyles = css`
    --_checkbox__color: var(--sbkCheckboxFgColorOnDarkDefault);
  --_checkbox__color--active: var(--sbkCheckboxFgColorOnDarkActive);
  --_checkbox__color--hover: var(--sbkCheckboxFgColorOnDarkHover);
  --_checkbox__color--focus: var(--sbkCheckboxFgColorOnDarkDefault);
    --_checkbox__color--disabled: var(--sbkCheckboxFgColorOnDarkDisabled);
    --_checkbox__color--error: var(--sbkCheckboxFgColorOnDarkError);

  --checkbox-icon__color: var(--sbkCheckboxFgColorOnLightDefault);
  --checkbox-icon__color--active: var(--sbkCheckboxFgColorOnLightDefault);
  --checkbox-icon__color--hover: var(--sbkCheckboxFgColorOnLightDefault);
  --checkbox-icon__color--focus: var(--sbkCheckboxFgColorOnLightDefault);
  --checkbox-icon__color--disabled: var(--sbkCheckboxFgColorOnLightDisabled);
  --checkbox-icon__color--error: var(--sbkCheckboxFgColorOnLightError);

    --_checkbox__bg: var(--sbkCheckboxBgColorOnDarkEnabled);
    --_checkbox__bg--active: var(--sbkCheckboxBgColorOnDarkActive);
    --_checkbox__bg--hover: var(--sbkCheckboxBgColorOnDarkHover);
    --_checkbox__bg--focus: var(--sbkCheckboxBgColorOnDarkFocus);
    --_checkbox__bg--disabled: var(--sbkCheckboxBgColorOnDarkDisabled);
    --_checkbox__bg--error: var(--sbkCheckboxBgColorOnDarkError);

    --_checkbox__border: var(--sbkCheckboxBorderOnDarkEnabled);
    --_checkbox__border--active: var(--sbkCheckboxBorderOnDarkActive);
    --_checkbox__border--disabled: var(--sbkCheckboxBorderOnDarkDisabled);
    --_checkbox__border--focus: var(--sbkCheckboxBorderOnDarkFocus);
    --_checkbox__border--hover: var(--sbkCheckboxBorderOnDarkHover);
    --_checkbox__border--readonly: var(--sbkCheckboxBorderOnDarkDisabled);
    --_checkbox__border--error: var(--sbkCheckboxBorderOnDarkError);
`;
